import {
  FaPoundSign, FaUsers, FaShoppingCart, FaChartLine, FaReceipt,
  FaUserTag, FaCalendarCheck, FaBoxes, FaChartBar, FaChartPie,
  FaTable, FaChevronLeft, FaChevronRight, FaArrowUp, FaArrowDown,
  FaFireAlt, FaTruck, FaWarehouse, FaMoneyBillWave, FaCashRegister,
  FaPercentage, FaBoxOpen, FaClipboardList, FaUserTie
} from 'react-icons/fa';

const iconMap = {
  FaPoundSign,
  FaUsers,
  FaShoppingCart,
  FaChartLine,
  FaReceipt,
  FaUserTag,
  FaCalendarCheck,
  FaBoxes,
  FaChartBar,
  FaChartPie,
  FaTable,
  FaChevronLeft,
  FaChevronRight,
  FaArrowUp,
  FaArrowDown,
  FaFireAlt,
  FaTruck,
  FaWarehouse,
  FaMoneyBillWave,
  FaCashRegister,
  FaPercentage,
  FaBoxOpen,
  FaClipboardList,
  FaUserTie,
};

export const resolveIcon = (iconName) => {
  return iconMap[iconName] || null;
};

export default resolveIcon;
